import { useState } from "react";
import { useQueryClient } from "react-query";
import {
  Button,
  Container,
  FormControl,
  FormLabel,
  Input,
  Stack,
  useBreakpointValue,
  Icon,
  useToast,
} from "@chakra-ui/react";
import { MdAdd } from "react-icons/md";

// local imports
import { createList } from "../services/firebase";

const CreateListForm = ({ uid }) => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const [title, setTitle] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const buttonSize = useBreakpointValue(["lg", "md"]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsDisable(true);

    const data = {
      uid: uid,
      title: title,
      todos: {},
    };

    await createList(data);

    toast({
      position: "top",
      title: "Successfully created new list",
      isClosable: true,
      status: "success",
      duration: 3000,
    });

    // fetch updated lists data from server
    queryClient.invalidateQueries("lists");

    setTitle("");
    setIsDisable(false);
  };

  return (
    <Container my={4}>
      <form onSubmit={handleSubmit}>
        <Stack
          direction={{ base: "column", sm: "row" }}
          align={{ base: "center", sm: "end" }}
        >
          <FormControl>
            <FormLabel hidden>Enter List Title</FormLabel>
            <Input
              type="text"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
              placeholder="List Title ..."
              isDisabled={isDisable}
            />
          </FormControl>
          <Button
            leftIcon={<Icon as={MdAdd} />}
            type="submit"
            size={buttonSize}
            colorScheme="teal"
            variant="outline"
            mt={3}
            isDisabled={isDisable}
          >
            List
          </Button>
        </Stack>
      </form>
    </Container>
  );
};

export default CreateListForm;
